import { Component, OnInit } from '@angular/core';

declare function init_plugins();
@Component({
  selector: 'app-core',
  templateUrl: './core.component.html'
})
export class CoreComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    init_plugins();
  }

}
